// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
export const PRESERVED_MASTER_NUMBERS = [11, 22]         ;
export const INTENTIONALLY_REDUCED_MASTER_NUMBERS = [33]         ;








function assertNaturalNumber(value        )       {
  if (!Number.isSafeInteger(value) || value < 0) {
    throw new RangeError('Numerology reductions require a non-negative safe integer.');
  }
}

export function sumDigits(value        )         {
  assertNaturalNumber(value);

  return String(value)
    .split('')
    .reduce((total, digit) => total + Number(digit), 0);
}

export function reduceToDigit(input        )                  {
  return reduceNumber(input, []);
}

export function reduceWithMasters(input        )                  {
  return reduceNumber(input, PRESERVED_MASTER_NUMBERS);
}

function reduceNumber(input        , masters                   )                  {
  assertNaturalNumber(input);

  const masterSet = new Set(masters);
  const stages = [input];
  let current = input;

  while (current > 9 && !masterSet.has(current)) {
    current = sumDigits(current);
    stages.push(current);
  }

  return {
    input,
    stages,
    value: current,
    preservedMaster: masterSet.has(current) ? current : null,
  };
}
